import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RevenueCalculator from "@/pages/RevenueCalculator";

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RevenueCalculator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;